<template>
  <b-modal 
    id="novo-vinculo-unidade"
    centered
    size="lg"
    :visible="false"
    :no-close-on-backdrop="true"
    :hide-footer="true"
    @hidden="resetForm"
  >
    <load v-if="loadingNewVinculo" mode="table" />
    <form v-else class="card-body p-3" @submit.prevent="addNewUnidade">
      <h4 class="card-title mb-3">
        <i class="fas fa-plus-circle"></i> Novo Vínculo com Unidade
      </h4>
      <div class="row">
        <form-select
          grid="6"
          v-model="unidade.unidade_id"
          :itens="unidades"
          :required="true"
          placeholder="Pesquise o nome de uma Unidade."
          label="Unidade"
        />
        <form-select
          grid="6"
          v-model="unidade.funcao_unidade"
          :itens="roles"
          :required="true"
          placeholder="Selecione uma Função"
          label="Função na Unidade/Sistema"
        />
      </div>
      <div class="row">
        <form-select
          v-model="unidade.regime_trabalho"
          :itens="$root.arrays.regimeTrabalhoTecnicos"
          placeholder="Selecione"
          label="Regime de Trabalho"
        />

        <form-calendar
          v-model="unidade.data_admissao"
          label="Data de Vinculação"
        />

        <form-calendar
          v-model="unidade.data_desvinculacao"
          label="Data de Desvinculação"
        />

        <form-select
          v-model="unidade.carga_horaria"
          :itens="$root.arrays.cargaHorariaTecnicos"
          :required="true"
          placeholder="Selecione"
          label="Carga Horária"
        />

        <form-select
          v-model="unidade.status"
          label="Status"
          grid="6"
          :itens="[
            { id: 1, value: 'ATIVO' },
            { id: 2, value: 'INATIVO' },
          ]"
          ajuda="A atualização deste campo para (INATIVO) bloqueia o acesso do técnico a unidade relacionada"
        />
      </div>
      <button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
          <i class="mdi mdi-content-save" /> {{ $t("Salvar") }}
      </button>
    </form>
  </b-modal>
</template>
<script>
export default {
  props: ["unidades", "roles", "index"],
  data() {
    return {
      loadingNewVinculo: false,
      unidade: {
        unidade_id: null,
        funcao_unidade: null,
        regime_trabalho: null,
        data_admissao: null,
        data_desvinculacao: null,
        carga_horaria: null,
        status: 1,
      },
      item: { status: 1 },
      unidades_tecnico: [],
    };
  },
  mounted() {
    this.getTecnico();
  },
  methods: {
    verifyKeyExist(obj, key) {
      return obj != null && Object.prototype.hasOwnProperty.call(obj, key);
    },
    addNewUnidade() {
      this.loadingNewVinculo = true;
      
      let size = this.item.unidades != null ? this.item.unidades.length : 0;

      if (size == 0) {
        this.unidades_tecnico[0] = {
          funcao_unidade: this.item.role_id,
          regime_trabalho: this.item.regime_trabalho,
          carga_horaria: this.item.carga_horaria,
          data_admissao: this.item.data_admissao,
          unidade_id: this.item.unidade_id,
          data_desvinculacao: this.item.data_desvinculacao,
        }
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      if (this.item.role_id.value == "Admin") {
          this.item.role_id = 1;
      }

      this.unidades_tecnico.push(this.unidade);
      this.item.unidades = this.unidades_tecnico;

      if (this.item.unidades && this.item.unidades.length > 0) {
          this.item.unidades = this.item.unidades.filter((element) => {
              if (element.unidade_id != null) {
                  return element;
              }
          });
      }

      axios
          .put(`api/dashboard/admin/tecnicos/${this.item.id}`, this.item)
          .then((response) => {
              this.$snack.success({
                  button: false,
                  text: response.data.data.message,
              });
          })
          .catch((error) => {
              this.$snack.danger({
                  button: false,
                  text: "Erro ao adicionar vínculo: " + error.message,
              });
          })
          .finally(() => {
              ladda.stop();
              this.loadingNewVinculo = false;
              location.reload();
          });  
    },
    getTecnico() {
            this.loading = true;
            axios
                .get("api/dashboard/tecnicos/" + this.$route.params.id)
                .then((response) => {
                    this.item = response.data.data;
                    this.unidades_tecnico = this.item.unidades;
                    this.statusAnterior = this.item.status;
                    if (this.item.role_id == 1) {
                        this.item.role_id = {
                            id: 1,
                            value: "Admin",
                        };
                        this.disabledRole = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        resetForm() {
            this.loadingNewVinculo = false;
            this.unidade = {
                unidade_id: null,
                funcao_unidade: null,
                regime_trabalho: null,
                data_admissao: null,
                data_desvinculacao: null,
                carga_horaria: null,
                status: 1,
            };
        }
  }
};
</script>